var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhsRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42_1037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2373 4.7625C12.1498 3.675 10.6573 3 8.99982 3C5.68482 3 3.00732 5.685 3.00732 9C3.00732 12.315 5.68482 15 8.99982 15C11.7973 15 14.1298 13.0875 14.7973 10.5H13.2373C12.6223 12.2475 10.9573 13.5 8.99982 13.5C6.51732 13.5 4.49982 11.4825 4.49982 9C4.49982 6.5175 6.51732 4.5 8.99982 4.5C10.2448 4.5 11.3548 5.0175 12.1648 5.835L9.74982 8.25H14.9998V3L13.2373 4.7625Z",
    fill: "#1E334E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42_1037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhsRefresh);
export default __webpack_public_path__ + "static/media/WHSRefresh.ca57d73418ebe8ff8a2d538a51dda357.svg";
export { ForwardRef as ReactComponent };